import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_cycle_bank_report_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_cycle_hdr_guid: fromDatatype.GuidDataFieldInterface;
  company_payment_date: fromDatatype.TimestampTzDatatypeInterface;
  company_code: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  claim_cycle_code: fromDatatype.VarcharDatatypeInterface;
  payment_description: fromDatatype.VarcharDatatypeInterface;
  total_payment_amount: fromDatatype.NumericDatatypeInterface;
  running_number: fromDatatype.NumericDatatypeInterface;
  payment_number: fromDatatype.NumericDatatypeInterface;
  employee_id: fromDatatype.VarcharDatatypeInterface;
  employee_code: fromDatatype.VarcharDatatypeInterface;
  employee_name: fromDatatype.VarcharDatatypeInterface;
  employee_email: fromDatatype.VarcharDatatypeInterface;
  employee_payment_description: fromDatatype.VarcharDatatypeInterface;
  bank_code: fromDatatype.VarcharDatatypeInterface;
  bank_name: fromDatatype.VarcharDatatypeInterface;
  account_number: fromDatatype.VarcharDatatypeInterface;
  payment_amount: fromDatatype.NumericDatatypeInterface;
  payment_detail_amount: fromDatatype.NumericDatatypeInterface;
  credit_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_claim_cycle_bank_report_line_RowClass implements bl_aat_claim_cycle_bank_report_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_cycle_hdr_guid: fromDatatype.GuidDataFieldInterface;
  company_payment_date: fromDatatype.TimestampTzDatatypeInterface;
  company_code: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  claim_cycle_code: fromDatatype.VarcharDatatypeInterface;
  payment_description: fromDatatype.VarcharDatatypeInterface;
  total_payment_amount: fromDatatype.NumericDatatypeInterface;
  running_number: fromDatatype.NumericDatatypeInterface;
  payment_number: fromDatatype.NumericDatatypeInterface;
  employee_id: fromDatatype.VarcharDatatypeInterface;
  employee_code: fromDatatype.VarcharDatatypeInterface;
  employee_name: fromDatatype.VarcharDatatypeInterface;
  employee_email: fromDatatype.VarcharDatatypeInterface;
  employee_payment_description: fromDatatype.VarcharDatatypeInterface;
  bank_code: fromDatatype.VarcharDatatypeInterface;
  bank_name: fromDatatype.VarcharDatatypeInterface;
  account_number: fromDatatype.VarcharDatatypeInterface;
  payment_amount: fromDatatype.NumericDatatypeInterface;
  payment_detail_amount: fromDatatype.NumericDatatypeInterface;
  credit_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}
